import styled from 'styled-components';

import { Caption, Caption2 } from '@components/styles/Typography';

const Price = ({ discountRate, discountedPrice, letterSpacing, price }) => (
    <PriceContainer letterSpacing={letterSpacing}>
        <PriceWrapper>
            <CurrentPrice>{discountedPrice}</CurrentPrice>
            {discountRate > 0 && <CampaignText>-%{discountRate}</CampaignText>}
        </PriceWrapper>
        {discountRate > 0 && <OldPrice>{price}</OldPrice>}
    </PriceContainer>
);

const PriceContainer = styled.div`
    display: flex;
    flex-direction: column;

    span {
        letter-spacing: ${({ letterSpacing }) => letterSpacing};
    }
`;
const OldPrice = styled(Caption2)`
    color: ${({ theme }) => theme.colors.bgGray25};
    text-decoration: line-through;
    margin-bottom: 4px;
`;
const CurrentPrice = styled(Caption)`
    margin-bottom: 4px;
`;
const PriceWrapper = styled.div`
    display: flex;
`;
const CampaignText = styled(Caption)`
    background-color: #000;
    color: ${({ theme }) => theme.colors.secondary};
    padding: 2px 3px 1px;
    margin: 0 0 0 11px;
    height: fit-content;

    @media (max-width: 1023px) {
        bottom: 80px;
    }
`;
export default Price;
